import { createFileRoute } from "@tanstack/react-router";
import { SignUpPage } from "~/components/orcaloops/SignUpDoor.tsx";
import { validateLoginSearch } from "~/lib/login-search.ts";
import { signUpDoorHead } from "./index.tsx";

/**
 * Catch-all beneath the orca sign-up door. The door drives Clerk's API itself
 * and never leaves `/sign-up`, but a stale link to one of Clerk's old
 * component steps (`/sign-up/verify-email-address`, `/sign-up/continue`, …)
 * still lands here and renders the same door rather than the site 404. Ranks
 * below the exact `index.tsx` and the static `sso-callback.tsx`.
 *
 * Only this route matches `/sign-up/<x>`, so it links the frame's sheet itself
 * through the shared {@link signUpDoorHead}; the page component is not
 * exported, so it splits into a route chunk.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/orca/sign-up/$")({
  validateSearch: validateLoginSearch,
  head: signUpDoorHead,
  component: SignUpCatchAllPage,
});

function SignUpCatchAllPage() {
  return <SignUpPage search={Route.useSearch()} />;
}
